export default __webpack_public_path__ + "static/media/servingfood.7ff8658c.jpg";